import { Camera } from "lucide-react";

// Only real photos provided by the Instituto. TODO: expandir com novas fotos.
const MOMENTOS = [
  {
    id: "oracao-circulo",
    src: "/uploads/enaga/enaga-oracao-circulo.jpg",
    alt: "Equipe do Instituto em círculo de oração antes das atividades",
    caption: "O ambiente vai além do espaço físico: começa na oração",
    cat: "Cristão",
  },
  {
    id: "ambiente-molda",
    src: "/uploads/enaga/enaga-ambiente.jpg",
    alt: "Voluntários do Instituto orando em círculo antes de atender as crianças",
    caption: "O ambiente molda o desenvolvimento infantil",
    cat: "Cristão",
  },
  {
    id: "inclusao",
    src: "/uploads/enaga/enaga-inclusao.jpg",
    alt: "Campanha ENAGA sobre ritmos de aprendizagem de cada criança",
    caption: "Cada criança aprende no seu próprio tempo, e nós respeitamos isso",
    cat: "Cristão",
  },
  {
    id: "comunhao",
    src: "/uploads/enaga/enaga-comunhao.jpg",
    alt: "Voluntárias do Instituto acolhendo criança em oficina criativa",
    caption: "Comunhão que acolhe: cuidar também é estar perto",
    cat: "Cristão",
  },
  {
    id: "oficina",
    src: "/uploads/enaga/enaga-oficina.jpg",
    alt: "Oficina de culinária com crianças do Instituto ENAGA",
    caption: "Oficina de culinária: crianças aprendendo e criando com carinho",
    cat: "ENAGA",
  },
  {
    id: "culinaria",
    src: "/uploads/enaga/enaga-culinaria.jpg",
    alt: "Crianças decorando cupcakes em oficina culinária do Instituto ENAGA",
    caption: "Cada detalhe vira aprendizado na oficina culinária",
    cat: "ENAGA",
  },
  {
    id: "alegria",
    src: "/uploads/enaga/enaga-alegria.jpg",
    alt: "Criança do Instituto ENAGA comendo cupcake decorado",
    caption: "O sorriso que vale todo o esforço",
    cat: "ENAGA",
  },
  {
    id: "sorriso",
    src: "/uploads/enaga/enaga-sorriso.jpg",
    alt: "Criança ENAGA em oficina alimentar com cupcake",
    caption: "Pequenos momentos, grandes conquistas",
    cat: "ENAGA",
  },
  {
    id: "acolhimento",
    src: "/uploads/enaga/enaga-acolhimento.jpg",
    alt: "Sala de acolhimento do Instituto ENAGA",
    caption: "Ambiente seguro preparado para receber cada criança",
    cat: "ENAGA",
  },
  {
    id: "autismo",
    src: "/uploads/enaga/enaga-autismo.jpg",
    alt: "Campanha de conscientização do autismo do Instituto ENAGA",
    caption: "Dia Mundial de Conscientização do Autismo",
    cat: "ENAGA",
  },
  {
    id: "atendimento",
    src: "/uploads/enaga/enaga-atendimento.jpg",
    alt: "Atendimento pedagógico individual no Instituto ENAGA",
    caption: "Atendimento especializado para cada criança",
    cat: "ENAGA",
  },
  {
    id: "desenvolvimento",
    src: "/uploads/enaga/enaga-desenvolvimento.jpg",
    alt: "Educação e desenvolvimento no Instituto",
    caption: "O desenvolvimento começa na educação",
    cat: "ENAGA",
  },
  {
    id: "basquete",
    src: "/uploads/ga/ga-basquete.jpg",
    alt: "Turma de basquete do Instituto Garotos da Arena",
    caption: "Turma de basquete: esporte como formação integral",
    cat: "Esporte",
  },
  {
    id: "jiujitsu",
    src: "/uploads/ga/ga-jiujitsu.jpg",
    alt: "Aulas de jiu-jitsu do Instituto Garotos da Arena com o Prof. Luiz Ricardo",
    caption: "Jiu-jitsu: disciplina, respeito e superação",
    cat: "Esporte",
  },
  {
    id: "ballet",
    src: "/uploads/ga/ga-ballet.jpg",
    alt: "Aula inaugural de ballet no Instituto Garotos da Arena",
    caption: "Aula inaugural de ballet: arte como caminho de cuidado",
    cat: "Arte",
  },
];

export default function Momentos() {
  return (
    <section
      id="momentos"
      data-testid="momentos-section"
      className="section-pad bg-white"
    >
      <div className="container-ga">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-10">
          <div className="max-w-2xl">
            <div className="pill border-ga-ink/10 text-ga-ink/70 bg-ga-ink/5 mb-5" data-testid="momentos-pill">
              <Camera className="w-3.5 h-3.5" />
              Momentos do Instituto
            </div>
            <h2 className="font-display font-black tracking-tighter text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-ga-ink">
              Registros reais de quem <span className="gradient-text-ga">vive a missão</span> todos os dias.
            </h2>
            <p className="mt-5 text-ga-ink/60 text-base sm:text-lg">
              Cada foto é um encontro, um atendimento, uma oficina, uma oração
              e uma vida sendo cuidada com atenção.
            </p>
          </div>
        </div>

        {/* Desktop: masonry-like responsive grid */}
        <div className="hidden md:grid grid-cols-3 lg:grid-cols-4 gap-4" data-testid="momentos-grid">
          {MOMENTOS.map((m, i) => (
            <figure
              key={m.id}
              data-testid={`momento-${m.id}`}
              className={`relative overflow-hidden rounded-2xl group hover-lift ${
                i === 0 ? "row-span-2 aspect-[3/4]" : (i === 3 ? "col-span-2 aspect-[16/9]" : "aspect-square")
              }`}
            >
              <img
                src={m.src}
                alt={m.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ga-ink via-ga-ink/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <figcaption className="absolute inset-x-0 bottom-0 p-4 opacity-0 group-hover:opacity-100 transition-all duration-500 translate-y-2 group-hover:translate-y-0">
                <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-ga-amber">
                  {m.cat}
                </div>
                <div className="text-white text-sm font-semibold mt-1 leading-snug">
                  {m.caption}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>

        {/* Mobile: horizontal snap carousel */}
        <div
          className="md:hidden -mx-6 px-6 flex gap-3 overflow-x-auto snap-x snap-mandatory scrollbar-none pb-3"
          data-testid="momentos-carousel"
        >
          {MOMENTOS.map((m) => (
            <figure
              key={m.id}
              className="relative shrink-0 w-[78%] aspect-[4/5] rounded-2xl overflow-hidden snap-start bg-ga-ink/5"
              data-testid={`momento-mobile-${m.id}`}
            >
              <img
                src={m.src}
                alt={m.alt}
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ga-ink/85 via-transparent to-transparent" />
              <figcaption className="absolute inset-x-0 bottom-0 p-4">
                <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-ga-amber">
                  {m.cat}
                </div>
                <div className="text-white text-sm font-semibold mt-1">
                  {m.caption}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
